import React from 'react';
import './Button.css';

const ButtonModelField = ( props ) => {
    const root = document.documentElement;
    const buttonBackgroundColor = getComputedStyle(root).getPropertyValue('--button_background-color').trim();
    const closeButtonBackgroundColor = getComputedStyle(root).getPropertyValue('--close-button_background-color').trim();
    const buttonTextColor = getComputedStyle(root).getPropertyValue('--button_text-color').trim();
    const closeButtonTextColor = getComputedStyle(root).getPropertyValue('--close-button_text-color').trim();
    let btnCls = {
        backgroundColor: 
        props.color === 'primary' ? buttonBackgroundColor : closeButtonBackgroundColor,
        color: props.color === 'primary' ? buttonTextColor : closeButtonTextColor,
    }; 
    // let btnCls = 'btn btn-outline-primary btn-rounded waves-effect';
    // btnCls = (props.color == 'danger') ? 'btn btn-outline-danger btn-rounded waves-effect' : 'btn btn-outline-primary btn-rounded waves-effect';
    return(
        <div>
            {/* <MDBBtn color={props.color} style={{
                // borderRadius: '17px',
                fontSize: '0.9rem',
                width:'13%',
                float:'right',
                marginRight: '5%',
            }}
                rounded
                type='button'
                className='btn-block z-depth-1 col-md-4'
                onClick={props.submit}
            >
            {props.BName}
            </MDBBtn> */}
            <button
                className = 'btnCls'
                style={btnCls}
                onClick={props.submit}
                disabled={props.disabled}
            >
                {props.BName}
            </button>
        </div>
    );
}

export default ButtonModelField;